const lang = {
    "Confirm Password": "パスワードを確認する。",
    "Next": "次へ",
    "Please enter a four-digit password.": "4桁のパスワードを入力してください。",
    "That's the wrong password! Please re-enter.": "間違ったパスワードです！ 再入力をお願いします。",
    "Enter Password": "パスワードを入力",
    "Please come back after checking.": "ご確認の上、お越しください。",
    "Please connect using the QR code.": "QRコードを読み取ってください。",
    "Expired QR Code": "QRコードが期限切れです。",
    "Invalid access.": "無効なアクセスです。",
    "An error has occurred.": "エラーが発生しました。",
    "Your data has been deleted.": "データが削除されました。",
    "To meet the new Virtual Smile, please request a new QR code.": "新しいバーチャルスマイルを作るために、新しいQRコードをリクエストします。",
    "Complete Setup": "セットアップを完了します",
    "To protect your privacy, you'll need to agree to use it and set a password.": "プライバシーを保護するために、それを使用することに同意し、パスワードを設定する必要があります。",
    "entry.button.set_password": "パスワードを設定",
    "Consent is required to set a password.": "以下の規約に同意して、パスワードの設定に進んでください。",
    "I have received an explanation of the Ray Virtual Smile service by the hospital and understand the information provided.": "私は、クリニックから Ray Virtual Smile サービスに関する説明を受け、その内容について理解しました。",
    "I have been given the opportunity by the hospital to ask questions about Ray Virtual Smile service.": "私は、クリニックに Ray Virtual Smile サービスの内容について問い合わせ、包括的な情報が提供されました。",
    "I voluntarily agree the proposed use of data in sharing.": "私は、私の個人データをクリニックと共有することに同意します。",
    "I agree that managing this password is solely my responsible.": "私は、上記サービスのパスワード管理に対する責任を理解し、受け入れることを確認します。",
    "I understand I can withdraw at any time without giving reasons and without being questioned, and that I will not be penalized for withdrawing.": "クリニックに連絡することで、いつでもこの同意を破棄できることを理解しました。",
    "Consent": "同意する",
    "Set Password": "パスワードを設定",
    "Please enter 4 numbers for your password.": "4桁のパスワードを入力してください。",
    "Confirm Password.": "パスワードを確認する。",
    "Please enter your password again.": "再度パスワードを入力してください。",
    "Please wait for a moment.": "少しお待ちください。",
    "Enter password": "パスワードを入力",
    "Please enter your password.": "パスワードを入力してください。",
    "The connection was rejected due to an abnormal access.": "アクセス異常により接続が拒否されました。",
    "Setting": "設定",
    "Language": "言語",
    "Delete All Items": "すべてのデータを削除",
    "Are you sure you want to delete? Erased data cannot be recovered.": "削除を続行してもよろしいですか? 一旦削除すると、データは復元できなくなります。",
    "Please enter your password to delete the data.": "ユーザーの要求に応じてデータを簡単に削除するには、パスワードの確認が必要です。",
    "This data was deleted by requesting of user.": "データは、ユーザーのリクエストにより削除されました。",
    "Make sure RAYTeams is logged in.": "RAYTeams にログインしていることを確認してください。",
    "\"Ray Virtual Smile\" could not be found, please create new one.": "「Ray Virtual Smile」は見つかりませんでした。 新しく作成してください。",
    "Data uploads are delayed due to poor network connectivity": "ネットワーク接続が悪いため、データのアップロードに時間がかかっています。",
    "Confirm": "確認します",
    "Delete": "削除します",
};

const trans = {
    ...lang,
}

export default trans;